export default "__VITE_ASSET__Cv15V1Ec__"